import { Button } from "@cms/components/data/Button"
import { StoriesPath } from "@cms/utils/routes"
import { socket } from "@cms/utils/socket"
import { useAppDispatch, useAppSelector } from "@cms/utils/store/hooks"
import { setEditorState } from "@cms/utils/store/slices/editor.slice"
import { checkRouteRequiredRole, IStoryLockRequestEvent, IStoryLockStateEvent, SOCKET_EVENTS } from "@dl/declarations"
import { useMemo } from "react"

export const LockStateGroup = () => {
    const dispatch = useAppDispatch();

    const { profile } = useAppSelector((state) => state.user)
    const { story, mode, state } = useAppSelector((state) => state.editor)

    const { _id: userId, permissions: userPermissions } = profile

    const handleLockStory = () => {
        socket.emit(SOCKET_EVENTS.LOCK_STORY, { story_id: story?._id, user_id: userId } as IStoryLockStateEvent)
    }

    const handleRequestLockStory = () => {
        socket.emit(SOCKET_EVENTS.REQUEST_LOCK_STORY, { story_id: story?._id, requester_user: profile } as IStoryLockRequestEvent)
        dispatch(setEditorState({ mode_status: 'requesting-edit' }))
    }

    const handleTakeOver = () => {
        handleLockStory()
    }

    const handleKnock = () => {
        handleRequestLockStory()
    }

    const hasPermissions = useMemo(() => {
        return checkRouteRequiredRole(StoriesPath, "u", userPermissions)
    }, [story, userPermissions])

    const buttonState = useMemo(() => {
        if (mode === 'editing') {
            return {
                type: 'hidden',
                title: 'Editing',
                tooltip: 'Story is locked by you, Click to unlock and convert to readonly mode'
            }
        }

        if (!hasPermissions) {
            return {
                type: 'hidden',
                title: 'View',
                tooltip: 'You do not have permissions to edit stories'
            }
        }

        return {
            type: 'enabled',
            title: 'Lock',
            tooltip: `Story is locked by ${story?.lockedByObject?.name || 'Unknown user'}, Click to lock and convert to editing mode`
        }
    }, [mode, hasPermissions])

    if (!story) {
        return null
    }

    if (buttonState.type === 'hidden') {
        return null
    }

    return (
        <div className="flex items-center gap-2">
            <Button
                type='button'
                onClick={handleTakeOver}
                disabled={buttonState.type === 'disabled' || state !== 'idle'}
                inputVariant='white_text_dark_orange_bg'
            >
                Takeover
            </Button>

            <Button
                type='button'
                onClick={handleKnock}
                disabled={buttonState.type === 'disabled' || state !== 'idle'}
            >
                Knock
            </Button>

        </div>
    )
}
